export default class Constants {
  /** 初診・再診選択肢 */
  static IsFirstTreatmentRadioOption = {
    Counseling: {
      value: '2',
      label: '無料カウンセリング'
    },
    FirstTreatment: {
      value: '1',
      label: '初診予約'
    },
    Revisit: {
      value: '0',
      label: '再診予約'
    }
  }

  static IsFirstTreatment(value: string): boolean {
    return value === this.IsFirstTreatmentRadioOption.FirstTreatment.value
  }

  /** 日付フォーマット */
  static DateFormat = {
    MM_DD_HH_mm: 'MM/DD HH:mm',
    YYYY_MM_DD_HH_mm: 'YYYY/MM/DD HH:mm',
    YYYY_MM_DD_HH_mm_ss: 'YYYY/MM/DD HH:mm:ss',
    YYYYMMDD: 'YYYYMMDD',
    YYYY_MM_DD: 'YYYY/MM/DD',
    YYYYNEN_MMGATU_DDNICHI: 'YYYY年MM月DD日',
    YYYYNEN_MMGATU_DDNICHI_ZIHUN: 'YYYY年MM月DD日 HH:mm',
    YYYYNEN_MMGATU_DDNICHI_YOUBI: 'YYYY年MM月DD日（dd）',
    YYYY_MM_DD_HYPHEN: 'YYYY-MM-DD',
    YYYY_MM_HYPHEN: 'YYYY-MM',
    Y: 'Y',
    M: 'M',
    D: 'D',
    dddd: 'dddd',
    HH_mm: 'HH:mm',
    mm: 'mm',
    dd: 'dd'
  }

  /** 診察タイプカテゴリ */
  static TreatmentCategoryOption = {
    OnLine: {
      label: 'オンライン診察',
      value: 'video'
    },
    Visit: {
      label: '来院診察',
      value: 'face_to_face'
    }
  }

  /** 性別 */
  static SexCategory = {
    MAN: 1,
    WOMAN: 0
  }
}